import { ObjectUtils } from "../../utils/ObjectUtils";

export class AlertaDto {

    static novo(partial: Partial<AlertaDto>): AlertaDto {

        const dto = new AlertaDto();
        dto.alerta = partial.alerta;
        dto.idProcesso = partial.idProcesso;
        dto.ativo = partial.ativo;
        return dto;
    }

    idProcesso: number;
    alerta: {
        descricaoAlerta: string;
        inCriticidade: string;
    };
    ativo: boolean;
}